import { Color, Vector2 } from "three";
import { Maps, useMaterial, useMeshPhysicalMaterial } from "@utils/useMaterial";

/* Textures - Modify as needed */
const maps: Partial<Maps> = {
    normalMap: ["T_Cardboard_N.jpg", {
        repeat: new Vector2(5, 5)
    }]
};

/* Preload textures */
useMaterial.preload(maps);

export default function useMat() {
    /* Create Material - Modify as needed */
    return useMeshPhysicalMaterial(maps, {
        color: new Color("#D7681F"),
        metalness: 0,
        roughness: 0.382759,
        normalScale: new Vector2(0.3, 0.3),
        envMapIntensity: 1,
    });
}